<ul [id]="'breadcrumb-' + brand" class="breadcrumb">
    @for (details of breadcrumb; track details) {
        <li class="breadcrumb-item">
            @if (details.url !== null) {
                <a href="{{ details.url }}">{{ details.label }}</a>
            }
            @if (details.url === null) {
                <span>{{ details.label }}</span>
            }
        </li>
    }
</ul>
